<template>
  <div class="login">
    <h1>ログイン画面</h1>
    <label>ID</label>
    <input v-model="id" style="padding: 10px;">
    &nbsp;&nbsp;&nbsp;&nbsp;
    <label>PASS</label>
    <input v-model="pass" style="padding: 10px;">
    <button @click="submit" style="display: block; margin: 0 auto; margin-top: 30px">ログイン</button>
  </div>
</template>

<script>
export default {
  name: 'HelloWorld',
  data () {
    return {
      id: '',
      pass: ''
    }
  },
  methods: {
    submit () {
      if (this.id === '' || this.pass === '') {
        alert('ID または パスワードを入力してください')
      } else {
        if (this.id === 'nobuhide4@gmail.com' && this.pass === 'nobu1234') {
          localStorage.setItem('login', 1)
          this.$router.push('/gourmet/isolate')
        } else {
          alert('ID または パスワードが間違っています')
          location.reload()
        }
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>



// WEBPACK FOOTER //
// src/components/login.vue